module.exports = __webpack_public_path__ + "img/11.886f8b69.png";